import axiosInstance from "../../../utils/axios";
import { QueryKeys } from "../../querys/querys.enum";
import { useAppQuery } from "../../querys/useAppQuery";

export interface IFilters {
  source?: string;
  fcmToken?: string;
  os?: string;
  model?: string;
  browser?: string;
  sourceDevice?: string;
  deviceUniqueld?: string;
}

const userDeviceInfoList = (userId:string, filters?: IFilters) => {
    return useAppQuery({
        queryKey: [QueryKeys.DEVICE_INFO, userId, filters], 
        queryFn: async () => {
            const queryParams = new URLSearchParams();
            
            if (filters?.source) queryParams.append('source', filters.source);
            if (filters?.fcmToken) queryParams.append('fcmToken', filters.fcmToken);
            if (filters?.os) queryParams.append('OS', filters.os);
            if (filters?.model) queryParams.append('model', filters.model);
            if (filters?.browser) queryParams.append('browser', filters.browser);
            if (filters?.sourceDevice) queryParams.append('sourceDevice', filters.sourceDevice);
            if (filters?.deviceUniqueld) queryParams.append('deviceUniqueld', filters.deviceUniqueld);
            
            const queryString = queryParams.toString();
            const url = `/users/devices/${userId}${queryString ? `?${queryString}` : ''}`;
            
            const response = await axiosInstance.get(url);
            return response.data;
        },
        enabled: !!userId,
        throwOnError: false,
        retry: 0,
        refetchInterval: 1000 * 60 * 5,
        _defaulted: true,
        gcTime: 1000 * 60 * 60 * 1,
        refetchOnWindowFocus: false,
    });
};

export default userDeviceInfoList;
